
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2051"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2051"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1oFqu", function(module, exports) {

$parcel$export(module.exports, "encodeUrlPayload", function () { return $08a0126f35029825$export$8d0f35cd8ab2231e; });
$parcel$export(module.exports, "decodeUrlPayload", function () { return $08a0126f35029825$export$d269922819925891; });
// https://github.com/crabbo-rave/CompressedBF
const $08a0126f35029825$var$charRange = [
    [
        32,
        126
    ],
    [
        160,
        255
    ],
    [
        256,
        383
    ],
    [
        384,
        591
    ],
    [
        592,
        687
    ],
    [
        688,
        767
    ],
    [
        880,
        1023
    ],
    [
        1024,
        1279
    ],
    [
        1280,
        1327
    ],
    [
        1328,
        1423
    ],
    [
        1424,
        1535
    ],
    [
        1536,
        1791
    ],
    [
        1792,
        1871
    ],
    [
        1920,
        1983
    ],
    [
        2304,
        2431
    ],
    [
        2432,
        2559
    ],
    [
        2560,
        2687
    ],
    [
        2688,
        2815
    ],
    [
        2816,
        2943
    ],
    [
        2944,
        3071
    ],
    [
        3072,
        3199
    ],
    [
        3200,
        3327
    ],
    [
        3328,
        3455
    ],
    [
        3456,
        3583
    ],
    [
        3584,
        3711
    ],
    [
        3712,
        3839
    ],
    [
        3840,
        4095
    ],
    [
        4096,
        4255
    ],
    [
        4256,
        4351
    ],
    [
        4352,
        4607
    ],
    [
        4608,
        4991
    ],
    [
        5024,
        5119
    ],
    [
        5120,
        5759
    ],
    [
        5760,
        5791
    ],
    [
        5792,
        5887
    ],
    [
        5888,
        5919
    ],
    [
        5920,
        5951
    ],
    [
        5952,
        5983
    ],
    [
        5984,
        6015
    ],
    [
        6016,
        6143
    ],
    [
        6144,
        6319
    ],
    [
        7680,
        7935
    ],
    [
        7936,
        8191
    ],
    [
        8192,
        8303
    ],
    [
        8352,
        8399
    ],
    [
        8448,
        8527
    ],
    [
        8528,
        8591
    ],
    [
        8592,
        8703
    ],
    [
        8704,
        8959
    ],
    [
        9472,
        9599
    ],
    [
        9600,
        9631
    ],
    [
        9632,
        9727
    ],
    [
        9728,
        9983
    ],
    [
        9984,
        10175
    ],
    [
        12352,
        12447
    ],
    [
        12448,
        12543
    ],
    [
        12544,
        12591
    ],
    [
        12592,
        12687
    ],
    [
        19968,
        20991
    ],
    [
        44032,
        45055
    ]
];
const $08a0126f35029825$var$operators = [
    '+',
    '-',
    '<',
    '>',
    '[',
    ']',
    '.',
    ','
];
const $08a0126f35029825$var$chars = $08a0126f35029825$var$charRange.flatMap(([start, end])=>Array.from({
        length: end - start + 1
    }, (_, i)=>String.fromCharCode(start + i)));
const $08a0126f35029825$var$combinations = [
    ...$08a0126f35029825$var$operators.flatMap((a)=>$08a0126f35029825$var$operators.map((b)=>a + b)),
    ...$08a0126f35029825$var$operators.flatMap((a)=>$08a0126f35029825$var$operators.flatMap((b)=>$08a0126f35029825$var$operators.map((c)=>a + b + c))),
    ...$08a0126f35029825$var$operators.flatMap((a)=>$08a0126f35029825$var$operators.flatMap((b)=>$08a0126f35029825$var$operators.flatMap((c)=>$08a0126f35029825$var$operators.map((d)=>a + b + c + d))))
];
if ($08a0126f35029825$var$combinations.length > $08a0126f35029825$var$chars.length) throw new Error('Not enough characters to encode all combinations');
const $08a0126f35029825$var$$ = Object.fromEntries($08a0126f35029825$var$combinations.map((combo, index)=>[
        combo,
        $08a0126f35029825$var$chars[index]
    ]));
const $08a0126f35029825$var$$$ = Object.fromEntries(Object.entries($08a0126f35029825$var$$).map(([k, v])=>[
        v,
        k
    ]));
// Base64url never contains '.', so this cannot collide with an existing compressed URL.
const $08a0126f35029825$var$correctionMarker = '.';
function $08a0126f35029825$var$toBase64Url(input) {
    const bytes = new TextEncoder().encode(input);
    let binary = '';
    for(let i = 0; i < bytes.length; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function $08a0126f35029825$var$fromBase64Url(input) {
    const base64 = input.replace(/-/g, '+').replace(/_/g, '/');
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (char)=>char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}
function $08a0126f35029825$var$encodeRuns(input) {
    if (Array.from(input).some((char)=>!$08a0126f35029825$var$operators.includes(char))) return null;
    return input.replace(/(.)\1*/g, (run)=>run[0] + (run.length > 1 ? run.length.toString(36) : ''));
}
function $08a0126f35029825$var$decodeRuns(input) {
    if (!/^(?:[+\-<>\[\].,][0-9a-z]*)+$/.test(input)) throw new Error('Invalid run-length payload');
    return input.replace(/([+\-<>\[\].,])([0-9a-z]*)/g, (_, operator, encodedCount)=>{
        const count = encodedCount ? parseInt(encodedCount, 36) : 1;
        if (!Number.isSafeInteger(count) || count < 1) throw new Error('Invalid run-length payload');
        return operator.repeat(count);
    });
}
function $08a0126f35029825$export$80908c17a05abbe5(input, literalIndexes = []) {
    let result = '';
    let i = 0;
    while(i < input.length){
        let matched = false;
        for(let len = 4; len >= 2; len--)if (i + len - 1 < input.length) {
            const key = input.substring(i, i + len);
            if ($08a0126f35029825$var$$[key]) {
                result += $08a0126f35029825$var$$[key];
                i += len;
                matched = true;
                break;
            }
        }
        if (!matched) {
            if ($08a0126f35029825$var$$$[input[i]]) literalIndexes.push(result.length);
            result += input[i];
            i++;
        }
    }
    return result;
}
function $08a0126f35029825$export$678d868aab8fb3c7(input, literalIndexes = new Set()) {
    let result = '';
    for(let i = 0; i < input.length; i++){
        const char = input[i];
        let found = false;
        if (!literalIndexes.has(i) && $08a0126f35029825$var$$$[char]) {
            result += $08a0126f35029825$var$$$[char];
            found = true;
        }
        if (!found) result += char;
    }
    return result;
}
function $08a0126f35029825$export$8d0f35cd8ab2231e(input) {
    const literalIndexes = [];
    const compressed = $08a0126f35029825$export$80908c17a05abbe5(input, literalIndexes);
    let payload = $08a0126f35029825$var$toBase64Url(compressed);
    // Preserve the existing URL exactly unless compression loses information.
    if (literalIndexes.length > 0) payload += $08a0126f35029825$var$correctionMarker + literalIndexes.map((index)=>index.toString(36)).join('-');
    const runs = $08a0126f35029825$var$encodeRuns(input);
    const runPayload = runs === null ? null : $08a0126f35029825$var$correctionMarker + $08a0126f35029825$var$toBase64Url(runs);
    return runPayload !== null && runPayload.length < payload.length ? runPayload : payload;
}
function $08a0126f35029825$export$d269922819925891(input) {
    if (input.startsWith($08a0126f35029825$var$correctionMarker)) return $08a0126f35029825$var$decodeRuns($08a0126f35029825$var$fromBase64Url(input.substring($08a0126f35029825$var$correctionMarker.length)));
    const markerIndex = input.indexOf($08a0126f35029825$var$correctionMarker);
    if (markerIndex === -1) return $08a0126f35029825$export$678d868aab8fb3c7($08a0126f35029825$var$fromBase64Url(input));
    const corrections = input.substring(markerIndex + $08a0126f35029825$var$correctionMarker.length);
    if (!/^[0-9a-z]+(?:-[0-9a-z]+)*$/.test(corrections)) throw new Error('Invalid URL corrections');
    const literalIndexes = new Set(corrections.split('-').map((index)=>parseInt(index, 36)));
    return $08a0126f35029825$export$678d868aab8fb3c7($08a0126f35029825$var$fromBase64Url(input.substring(0, markerIndex)), literalIndexes);
}

});

class $533472b684d96bba$export$2e2bcd8739ae039 {
    cells = [];
    at = 0;
    index = 0;
    input = "";
    loopAnchors = [];
    result = "";
    _onInputRequest = null;
    constructor(input){
        this.input = input;
    }
    onInputRequest(handler) {
        this._onInputRequest = handler;
        return this;
    }
    async run() {
        while(await this.nextStep());
        return this.result;
    }
    async nextStep() {
        if (this.index >= this.input.length) return false;
        const operator = this.input[this.index];
        if (operator === "+") {
            const currentValue = this.cells[this.at] ?? 0;
            if (currentValue === 255) this.cells[this.at] = 0;
            else this.cells[this.at] = currentValue + 1;
        } else if (operator === "-") {
            const currentValue = this.cells[this.at] ?? 0;
            if (currentValue === 0) this.cells[this.at] = 255;
            else this.cells[this.at] = currentValue - 1;
        } else if (operator === ">") {
            if (this.at < 30000) this.at++;
        } else if (operator === "<") {
            if (this.at > 0) this.at--;
        } else if (operator === "[") {
            const currentValue = this.cells[this.at] ?? 0;
            if (currentValue === 0) {
                let depth = 1;
                while(depth > 0){
                    this.index++;
                    if (this.index >= this.input.length) throw new Error("Unmatched '[' in program");
                    if (this.input[this.index] === "[") depth++;
                    else if (this.input[this.index] === "]") depth--;
                }
            } else this.loopAnchors.push(this.index);
        } else if (operator === "]") {
            const currentValue = this.cells[this.at] ?? 0;
            if (currentValue !== 0) {
                if (this.loopAnchors.length === 0) throw new Error("Unmatched ']' in program");
                this.index = this.loopAnchors[this.loopAnchors.length - 1];
            } else {
                if (this.loopAnchors.length === 0) throw new Error("Unmatched ']' in program");
                this.loopAnchors.splice(this.loopAnchors.length - 1, 1);
            }
        } else if (operator === ".") this.result += String.fromCharCode(this.cells[this.at]);
        else if (operator === ",") {
            if (this._onInputRequest) {
                const value = await this._onInputRequest();
                this.cells[this.at] = value & 255;
            } else this.cells[this.at] = 0;
        }
        this.index++;
        return true;
    }
    snapshot() {
        return {
            index: this.index,
            pointer: this.at,
            cells: [
                ...this.cells
            ],
            result: this.result
        };
    }
}


/**
 * List of known SVG tag names.
 *
 * @type {Array<string>}
 */ const $7e388ed46550082c$export$bf991a7e885a4e4c = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'animation',
    'audio',
    'canvas',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'discard',
    'ellipse',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-src',
    'font-face-uri',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'handler',
    'hkern',
    'iframe',
    'image',
    'line',
    'linearGradient',
    'listener',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'prefetch',
    'radialGradient',
    'rect',
    'script',
    'set',
    'solidColor',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'tbreak',
    'text',
    'textArea',
    'textPath',
    'title',
    'tref',
    'tspan',
    'unknown',
    'use',
    'video',
    'view',
    'vkern'
];


const $35c245714e2863e8$var$svgTags = new Set((0, $7e388ed46550082c$export$bf991a7e885a4e4c));
$35c245714e2863e8$var$svgTags.delete('a');
$35c245714e2863e8$var$svgTags.delete('audio');
$35c245714e2863e8$var$svgTags.delete('canvas');
$35c245714e2863e8$var$svgTags.delete('iframe');
$35c245714e2863e8$var$svgTags.delete('script');
$35c245714e2863e8$var$svgTags.delete('video');
const $35c245714e2863e8$var$processedAttributes = [
    'htmlFor',
    'for',
    'class',
    'className',
    'style',
    'dangerouslySetInnerHTML',
    '__source',
    '__self'
];
// Copied from Preact
// https://github.com/preactjs/preact/blob/1bbd687c13c1fd16f0d6393e79ea6232f55fbec4/src/constants.js#L3
const $35c245714e2863e8$var$IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
const $35c245714e2863e8$var$isFragment = (type)=>type === DocumentFragment;
const $35c245714e2863e8$var$setCSSProps = (element, style)=>{
    for (const [name, value] of Object.entries(style)){
        if (name.startsWith('-')) element.style.setProperty(name, value);
        else if (typeof value === 'number' && !$35c245714e2863e8$var$IS_NON_DIMENSIONAL.test(name)) element.style[name] = `${value}px`;
        else element.style[name] = value;
    }
};
const $35c245714e2863e8$var$create = (type, attributes = {})=>{
    if (typeof type === 'string') {
        if ($35c245714e2863e8$var$svgTags.has(type)) return document.createElementNS('http://www.w3.org/2000/svg', type);
        return document.createElement(type);
    }
    if ($35c245714e2863e8$var$isFragment(type)) return document.createDocumentFragment();
    // make shallow copy of provided attributes
    const filteredProps = Object.assign({}, attributes);
    // filter out processed attributes
    Object.keys(filteredProps).filter((key)=>key.startsWith("on") || $35c245714e2863e8$var$processedAttributes.includes(key)).forEach((key)=>delete filteredProps[key]);
    // join the default props and provided attributes
    const props = Object.assign({}, type.defaultProps || {}, filteredProps);
    return type(props);
};
const $35c245714e2863e8$var$setAttribute = (element, name, value)=>{
    if (value === undefined || value === null) return;
    // Naive support for xlink namespace
    // Full list: https://github.com/facebook/react/blob/1843f87/src/renderers/dom/shared/SVGDOMPropertyConfig.js#L258-L264
    if (/^xlink[AHRST]/.test(name)) element.setAttributeNS('http://www.w3.org/1999/xlink', name.replace('xlink', 'xlink:').toLowerCase(), value);
    else element.setAttribute(name, value);
};
const $35c245714e2863e8$var$addChildren = (parent, children)=>{
    for (const child of children){
        if (child instanceof Node) parent.appendChild(child);
        else if (Array.isArray(child)) $35c245714e2863e8$var$addChildren(parent, child);
        else if (typeof child !== 'boolean' && typeof child !== 'undefined' && child !== null) parent.appendChild(document.createTextNode(child));
    }
};
// These attributes allow "false" as a valid value
// https://github.com/facebook/react/blob/3f8990898309c61c817fbf663f5221d9a00d0eaa/packages/react-dom/src/shared/DOMProperty.js#L288-L322
const $35c245714e2863e8$var$booleanishAttributes = new Set([
    // These attributes allow "false" as a valid value
    'contentEditable',
    'draggable',
    'spellCheck',
    'value',
    // SVG-specific
    'autoReverse',
    'externalResourcesRequired',
    'focusable',
    'preserveAlpha'
]);
const $35c245714e2863e8$export$dda1d9f60106f0e9 = (type, attributes, ...children)=>{
    var _a;
    const element = $35c245714e2863e8$var$create(type, attributes);
    $35c245714e2863e8$var$addChildren(element, children);
    if (element instanceof DocumentFragment || !attributes) return element;
    // ignore the attr if it's a prop and set attributes
    (typeof type === "function" ? Object.entries(attributes).filter(([name])=>!Object.keys(type.defaultProps ?? {}).includes(name)) : Object.entries(attributes)).forEach(([name, value])=>{
        if (name === 'htmlFor') name = 'for';
        if (name === 'class' || name === 'className') {
            const existingClassname = (_a = element.getAttribute('class')) !== null && _a !== void 0 ? _a : '';
            $35c245714e2863e8$var$setAttribute(element, 'class', (existingClassname + ' ' + String(value)).trim());
        } else if (name === 'style') $35c245714e2863e8$var$setCSSProps(element, value);
        else if (name.startsWith('on')) {
            const eventName = name.slice(2).toLowerCase().replace(/^-/, '');
            element.addEventListener(eventName, value);
        } else if (name === 'dangerouslySetInnerHTML' && '__html' in value) element.innerHTML = value.__html;
        else if (name !== 'key' && ($35c245714e2863e8$var$booleanishAttributes.has(name) || value !== false)) {
            let nV = undefined;
            if (typeof value === "string") nV = value;
            else if (typeof value === "number") nV = String(value);
            else if (typeof value === "boolean") nV = value ? "true" : "false";
            else if (value === null) nV = "null";
            if (nV !== undefined) $35c245714e2863e8$var$setAttribute(element, name, nV);
        }
    });
    return element;
};
const $35c245714e2863e8$export$ffb0004e005737fa = typeof DocumentFragment === 'function' ? DocumentFragment : ()=>{};
// Improve TypeScript support for DocumentFragment
// https://github.com/Microsoft/TypeScript/issues/20469
const $35c245714e2863e8$var$React = {
    createElement: $35c245714e2863e8$export$dda1d9f60106f0e9,
    Fragment: $35c245714e2863e8$export$ffb0004e005737fa
};
var $35c245714e2863e8$export$2e2bcd8739ae039 = $35c245714e2863e8$var$React;


let $24759e9477ddbbce$export$9a77307cf9e1cce, $24759e9477ddbbce$export$df4382c94ffa9da5;
if (window.getSelection && document.createRange) {
    $24759e9477ddbbce$export$9a77307cf9e1cce = function(containerEl) {
        let range = window.getSelection().getRangeAt(0);
        let preSelectionRange = range.cloneRange();
        preSelectionRange.selectNodeContents(containerEl);
        preSelectionRange.setEnd(range.startContainer, range.startOffset);
        let start = preSelectionRange.toString().length;
        return {
            start: start,
            end: start + range.toString().length
        };
    };
    $24759e9477ddbbce$export$df4382c94ffa9da5 = function(containerEl, savedSel) {
        let charIndex = 0, range = document.createRange();
        range.setStart(containerEl, 0);
        range.collapse(true);
        let nodeStack = [
            containerEl
        ], node, foundStart = false, stop = false;
        while(!stop && (node = nodeStack.pop()))if (node.nodeType === 3) {
            let nextCharIndex = charIndex + node.length;
            if (!foundStart && savedSel.start >= charIndex && savedSel.start <= nextCharIndex) {
                range.setStart(node, savedSel.start - charIndex);
                foundStart = true;
            }
            if (foundStart && savedSel.end >= charIndex && savedSel.end <= nextCharIndex) {
                range.setEnd(node, savedSel.end - charIndex);
                stop = true;
            }
            charIndex = nextCharIndex;
        } else {
            let i = node.childNodes.length;
            while(i--)nodeStack.push(node.childNodes[i]);
        }
        let sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    };
} else if (document.selection) {
    $24759e9477ddbbce$export$9a77307cf9e1cce = function(containerEl) {
        let selectedTextRange = document.selection.createRange();
        let preSelectionTextRange = document.body.createTextRange();
        preSelectionTextRange.moveToElementText(containerEl);
        preSelectionTextRange.setEndPoint("EndToStart", selectedTextRange);
        let start = preSelectionTextRange.text.length;
        return {
            start: start,
            end: start + selectedTextRange.text.length
        };
    };
    $24759e9477ddbbce$export$df4382c94ffa9da5 = function(containerEl, savedSel) {
        let textRange = document.body.createTextRange();
        textRange.moveToElementText(containerEl);
        textRange.collapse(true);
        textRange.moveEnd("character", savedSel.end);
        textRange.moveStart("character", savedSel.start);
        textRange.select();
    };
}



class $8f584bba2bb74fa8$export$2e2bcd8739ae039 extends HTMLElement {
    closeable = true;
    removeFromDomOnClose;
    constructor(removeFromDomOnClose = false){
        super();
        this.attachShadow({
            mode: 'open'
        });
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    position: fixed;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    background-color: #0000009e;
                    z-index: 1001;
                    display: none;
                }
            </style>
            <slot></slot>
        `;
        this.removeFromDomOnClose = removeFromDomOnClose;
        let startElement = null;
        this.addEventListener("mousedown", (e)=>{
            startElement = e.target;
        });
        this.addEventListener("mouseup", (e)=>{
            if (e.target === startElement && e.target === this && this.isCloseable()) this.close();
            startElement = null;
        });
        this.append(/*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("i", {
            className: "codicon codicon-chrome-close",
            onclick: ()=>{
                if (this.isCloseable()) this.close();
            }
        }));
        window.addEventListener("keyup", (e)=>{
            if (this.isCloseable() && e.key === "Escape" && !e.ctrlKey && !e.shiftKey && !e.altKey) this.close();
        });
    }
    isOpen() {
        return document.body.contains(this) && this.style.display !== "none";
    }
    open() {
        this.style.display = "block";
        if (!document.body.contains(this)) document.body.append(this);
        document.body.style.overflow = "hidden";
        this.dispatchEvent(new Event("open"));
    }
    close() {
        if (this.removeFromDomOnClose) this.remove();
        this.style.display = "";
        document.body.style.overflow = "";
        this.dispatchEvent(new Event("close"));
    }
    isCloseable() {
        return this.closeable;
    }
    setCloseable(toggle) {
        this.closeable = typeof toggle === "boolean" ? toggle : this.closeable;
    }
}



var $1oFqu = parcelRequire("1oFqu");
window.customElements.define('x-modal', (0, $8f584bba2bb74fa8$export$2e2bcd8739ae039));
const $3f2d68c8e82ce3a4$var$textarea = document.querySelector("div.textarea"), $3f2d68c8e82ce3a4$var$runButton = document.querySelector('div.input button[data-action="run"]'), $3f2d68c8e82ce3a4$var$debugButton = document.querySelector('div.input button[data-action="debug"]'), $3f2d68c8e82ce3a4$var$shareButton = document.querySelector('div.input button[data-action="share"]');
let $3f2d68c8e82ce3a4$var$debug = null;
let $3f2d68c8e82ce3a4$var$encoderTracked = false;
let $3f2d68c8e82ce3a4$var$inp = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("textarea", {
    onInput: ()=>$3f2d68c8e82ce3a4$var$do_generate()
}, "Hello World"), $3f2d68c8e82ce3a4$var$out = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("textarea", {
    disabled: true
});
const $3f2d68c8e82ce3a4$var$update = ()=>{
    const pos = document.activeElement === $3f2d68c8e82ce3a4$var$textarea ? (0, $24759e9477ddbbce$export$9a77307cf9e1cce)($3f2d68c8e82ce3a4$var$textarea) : undefined;
    $3f2d68c8e82ce3a4$var$textarea.innerHTML = $3f2d68c8e82ce3a4$var$colorizeBF($3f2d68c8e82ce3a4$var$textarea.innerText);
    if (pos) (0, $24759e9477ddbbce$export$df4382c94ffa9da5)($3f2d68c8e82ce3a4$var$textarea, pos);
    const empty = $3f2d68c8e82ce3a4$var$textarea.innerText.trim().length <= 0;
    $3f2d68c8e82ce3a4$var$runButton.disabled = empty;
    $3f2d68c8e82ce3a4$var$debugButton.disabled = empty;
    $3f2d68c8e82ce3a4$var$shareButton.disabled = empty;
};
const $3f2d68c8e82ce3a4$var$colorizeBF = (input, emphasize = false)=>{
    return input.replaceAll(/(<)(?![a\/])/g, `&lt;`).replaceAll(/(?<!["a])(>)/g, `&gt;`).replaceAll(/((?:&lt;)+)/g, `<span operator="<"${emphasize ? " emphasis" : ""}>$1</span>`).replaceAll(/((?:&gt;)+)/g, `<span operator=">"${emphasize ? " emphasis" : ""}>$1</span>`).replaceAll(/(\++)/g, `<span operator="+"${emphasize ? " emphasis" : ""}>$1</span>`).replaceAll(/(-+)/g, `<span operator="-"${emphasize ? " emphasis" : ""}>$1</span>`).replaceAll(/(\.+)/g, `<span operator="."${emphasize ? " emphasis" : ""}>$1</span>`).replaceAll(/(,+)/g, `<span operator=","${emphasize ? " emphasis" : ""}>$1</span>`).replaceAll(/(\[)/g, `<span operator="["${emphasize ? " emphasis" : ""}>$1</span>`).replaceAll(/(])/g, `<span operator="]"${emphasize ? " emphasis" : ""}>$1</span>`).replaceAll(/\n/g, `<br>`);
};
$3f2d68c8e82ce3a4$var$textarea.oninput = ()=>{
    if ($3f2d68c8e82ce3a4$var$debug !== null) $3f2d68c8e82ce3a4$var$exitDebug();
    $3f2d68c8e82ce3a4$var$update();
};
$3f2d68c8e82ce3a4$var$update();
if (window.location.hash.length > 1) try {
    const raw = window.location.hash.substring(1);
    let code;
    if (raw.includes('%')) // Legacy format: percent-encoded BF code
    code = decodeURIComponent(raw);
    else code = (0, $1oFqu.decodeUrlPayload)(raw);
    if (code.trim().length > 0) {
        $3f2d68c8e82ce3a4$var$textarea.innerText = code;
        $3f2d68c8e82ce3a4$var$update();
        plausible('Code Loaded from URL');
    }
} catch (e) {}
const $3f2d68c8e82ce3a4$var$requestInput = ()=>{
    return new Promise((resolve)=>{
        const modal = new (0, $8f584bba2bb74fa8$export$2e2bcd8739ae039)(true);
        modal.setCloseable(false);
        let inputField = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("input", {
            type: "text",
            maxLength: 1,
            placeholder: "Type a character",
            className: "input-field"
        });
        let submitButton = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("button", {
            className: "success",
            style: {
                marginTop: "10px"
            }
        }, "Submit");
        const submit = ()=>{
            const char = inputField.value;
            if (char.length === 0) return;
            modal.setCloseable(true);
            modal.close();
            resolve(char.charCodeAt(0) & 255);
        };
        submitButton.onclick = submit;
        inputField.onkeydown = (e)=>{
            if (e.key === "Enter") {
                e.preventDefault();
                if (inputField.value.length === 0) {
                    // Enter with empty field = newline character (ASCII 10)
                    modal.setCloseable(true);
                    modal.close();
                    resolve(10);
                } else submit();
            }
        };
        modal.append(/*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", {
            className: "container",
            style: {
                maxWidth: "400px"
            }
        }, /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("main", null, /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("h3", null, "Input Requested"), /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("p", null, "The program is requesting a character input."), inputField, submitButton)));
        modal.open();
        inputField.focus();
    });
};
$3f2d68c8e82ce3a4$var$runButton.onclick = async (e)=>{
    if ($3f2d68c8e82ce3a4$var$textarea.innerText.trim().length) {
        plausible('Code Executed', {
            props: {
                code_length: String($3f2d68c8e82ce3a4$var$textarea.innerText.replace(/[^+\-<>.,\[\]]/g, '').length)
            }
        });
        $3f2d68c8e82ce3a4$var$runButton.disabled = true;
        $3f2d68c8e82ce3a4$var$debugButton.disabled = true;
        let bf = new (0, $533472b684d96bba$export$2e2bcd8739ae039)($3f2d68c8e82ce3a4$var$textarea.innerText);
        bf.onInputRequest($3f2d68c8e82ce3a4$var$requestInput);
        await bf.run();
        document.querySelector("div.output > div.textarea").innerText = bf.result;
        $3f2d68c8e82ce3a4$var$runButton.disabled = false;
        $3f2d68c8e82ce3a4$var$debugButton.disabled = false;
    }
};
const $3f2d68c8e82ce3a4$var$exitDebug = ()=>{
    $3f2d68c8e82ce3a4$var$debug = null;
    $3f2d68c8e82ce3a4$var$runButton.disabled = false;
    $3f2d68c8e82ce3a4$var$debugButton.classList.remove("danger");
    $3f2d68c8e82ce3a4$var$debugButton.classList.add("info");
    $3f2d68c8e82ce3a4$var$debugButton.querySelector("i").classList.remove("codicon-debug-disconnect");
    $3f2d68c8e82ce3a4$var$debugButton.querySelector("i").classList.add("codicon-debug-alt");
    document.querySelector("div.debugger").remove();
    $3f2d68c8e82ce3a4$var$update();
};
$3f2d68c8e82ce3a4$var$debugButton.onclick = async (e)=>{
    if ($3f2d68c8e82ce3a4$var$textarea.innerText.trim().length) {
        if ($3f2d68c8e82ce3a4$var$debug === null) {
            plausible('Debug Started', {
                props: {
                    code_length: String($3f2d68c8e82ce3a4$var$textarea.innerText.replace(/[^+\-<>.,\[\]]/g, '').length)
                }
            });
            $3f2d68c8e82ce3a4$var$runButton.disabled = true;
            $3f2d68c8e82ce3a4$var$debugButton.classList.remove("info");
            $3f2d68c8e82ce3a4$var$debugButton.classList.add("danger");
            $3f2d68c8e82ce3a4$var$debugButton.querySelector("i").classList.remove("codicon-debug-alt");
            $3f2d68c8e82ce3a4$var$debugButton.querySelector("i").classList.add("codicon-debug-disconnect");
            const bf = new (0, $533472b684d96bba$export$2e2bcd8739ae039)($3f2d68c8e82ce3a4$var$textarea.innerText);
            bf.onInputRequest($3f2d68c8e82ce3a4$var$requestInput);
            const steps = [
                bf.snapshot()
            ];
            let stepIndex = 0;
            let finished = false;
            let stepping = false;
            $3f2d68c8e82ce3a4$var$debug = {
                bf: bf,
                steps: steps,
                stepIndex: stepIndex
            };
            // init debug elements
            const debuggerElement = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", {
                className: "debugger"
            });
            const cellsWrapper = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", {
                className: "cells-wrapper"
            });
            const cellsElement = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", {
                className: "cells"
            });
            let debugPreviousButton, debugNextButton;
            let pointer = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("i", {
                className: "pointer codicon codicon-debug-breakpoint-function-unverified"
            });
            const rebuild = ()=>{
                const step = steps[stepIndex];
                const maxCells = Math.max(15, step.cells.length);
                cellsElement.innerHTML = "";
                for(let i = 0; i < maxCells; i++){
                    const val = step.cells[i] ?? 0;
                    cellsElement.append(/*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", {
                        className: "cell"
                    }, /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("span", null, i), /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("p", null, val), /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("small", null, String.fromCharCode(val))));
                }
                pointer.style.transform = `translate(calc(54px * ${step.pointer ?? 0} + 26px - 50%), 30px)`;
                debugPreviousButton.disabled = stepIndex === 0;
                debugNextButton.disabled = stepIndex === steps.length - 1 && finished;
                document.querySelector("div.output div.textarea").innerText = step.result;
                let prefix = bf.input.substring(0, step.index - 1);
                let emphasized = bf.input.substring(step.index - 1, step.index);
                let suffix = bf.input.substring(step.index);
                $3f2d68c8e82ce3a4$var$textarea.innerHTML = `${$3f2d68c8e82ce3a4$var$colorizeBF(prefix)}${$3f2d68c8e82ce3a4$var$colorizeBF(emphasized, true)}${$3f2d68c8e82ce3a4$var$colorizeBF(suffix)}`;
                cellsElement.append(pointer);
            };
            const stepForward = async ()=>{
                if (stepping || stepIndex === steps.length - 1 && finished) return;
                stepping = true;
                debugNextButton.disabled = true;
                debugPreviousButton.disabled = true;
                if (stepIndex < steps.length - 1) stepIndex++;
                else {
                    const cont = await bf.nextStep();
                    if (cont) {
                        steps.push(bf.snapshot());
                        stepIndex++;
                    } else finished = true;
                }
                stepping = false;
                rebuild();
            };
            cellsWrapper.append(cellsElement);
            const controlsElement = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", {
                className: "controls"
            });
            {
                let playing = false, playTimerId = NaN;
                const playPauseButton = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("button", null);
                const playPauseButtonIcon = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("i", {
                    className: "codicon codicon-debug-start"
                });
                playPauseButton.append(playPauseButtonIcon);
                debugNextButton = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("button", null, /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("i", {
                    className: "codicon codicon-debug-continue"
                }));
                debugPreviousButton = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("button", {
                    disabled: true
                }, /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("i", {
                    className: "codicon codicon-debug-reverse-continue"
                }));
                controlsElement.append(debugPreviousButton, playPauseButton, debugNextButton);
                debugNextButton.onclick = ()=>stepForward();
                debugPreviousButton.onclick = ()=>{
                    stepIndex--;
                    rebuild();
                };
                const stopPlaying = ()=>{
                    playing = false;
                    if (!isNaN(playTimerId)) {
                        clearTimeout(playTimerId);
                        playTimerId = NaN;
                    }
                };
                const autoPlayTick = async ()=>{
                    if (!playing || $3f2d68c8e82ce3a4$var$debug === null) {
                        stopPlaying();
                        playPauseButtonIcon.classList.remove("codicon-debug-pause");
                        playPauseButtonIcon.classList.add("codicon-debug-rerun");
                        return;
                    }
                    if (stepIndex === steps.length - 1 && finished) {
                        stopPlaying();
                        playPauseButtonIcon.classList.remove("codicon-debug-pause");
                        playPauseButtonIcon.classList.add("codicon-debug-rerun");
                        return;
                    }
                    await stepForward();
                    if (playing) playTimerId = setTimeout(autoPlayTick, 100);
                };
                playPauseButton.onclick = ()=>{
                    if (playing) {
                        stopPlaying();
                        playPauseButtonIcon.classList.remove("codicon-debug-pause");
                        playPauseButtonIcon.classList.add("codicon-debug-start");
                    } else {
                        if (stepIndex === steps.length - 1 && finished) stepIndex = 0;
                        playPauseButtonIcon.classList.remove("codicon-debug-rerun");
                        playPauseButtonIcon.classList.remove("codicon-debug-start");
                        playPauseButtonIcon.classList.add("codicon-debug-pause");
                        playing = true;
                        playTimerId = setTimeout(autoPlayTick, 100);
                    }
                };
            }
            rebuild();
            debuggerElement.append(cellsWrapper, controlsElement);
            document.querySelector("div.input").after(debuggerElement);
        } else $3f2d68c8e82ce3a4$var$exitDebug();
    }
};
$3f2d68c8e82ce3a4$var$shareButton.onclick = async ()=>{
    const code = $3f2d68c8e82ce3a4$var$textarea.innerText.trim();
    if (code.length) {
        const url = `${window.location.origin}/#${(0, $1oFqu.encodeUrlPayload)(code)}`;
        await navigator.clipboard.writeText(url);
        plausible('Code Shared');
        const icon = $3f2d68c8e82ce3a4$var$shareButton.querySelector("i");
        $3f2d68c8e82ce3a4$var$shareButton.firstChild.textContent = "Copied! ";
        icon.className = "codicon codicon-check";
        setTimeout(()=>{
            $3f2d68c8e82ce3a4$var$shareButton.firstChild.textContent = "Share ";
            icon.className = "codicon codicon-link";
        }, 2000);
    }
};
document.querySelector('button[data-action="ascii-table"]').onclick = (e)=>{
    plausible('ASCII Table Opened');
    const modal = new (0, $8f584bba2bb74fa8$export$2e2bcd8739ae039)(true);
    modal.append(/*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", {
        className: "container",
        style: {
            maxWidth: "800px"
        }
    }, /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("main", null, /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("h3", null, "ASCII Table"), /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", {
        className: "ascii-table"
    }, Array(256).fill(0).map((_, i)=>/*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", null, /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("span", null, i), /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("span", null, String.fromCharCode(i))))))));
    modal.open();
};
document.querySelector('button[data-action="encode"]').onclick = (e)=>{
    $3f2d68c8e82ce3a4$var$encoderTracked = false;
    const modal = new (0, $8f584bba2bb74fa8$export$2e2bcd8739ae039)(true);
    modal.append(/*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", {
        className: "container",
        style: {
            maxWidth: "800px"
        }
    }, /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("main", null, /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("h3", null, "Text Encoder"), $3f2d68c8e82ce3a4$var$inp, $3f2d68c8e82ce3a4$var$out)));
    modal.open();
};
window.onmouseover = (e)=>{
    [
        ...document.querySelectorAll("div.tooltip")
    ].forEach((el)=>el.remove());
    if (e.target.matches("span[operator]")) {
        const operator = e.target.getAttribute("operator");
        let p = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("p", null);
        const tooltip = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("div", {
            className: "tooltip"
        }, p);
        let count = e.target.innerText.length;
        if (operator === ">") p.innerHTML = `<b>Increment Data Pointer</b> - Moves the pointer to the right ${count} time${count > 1 ? "s" : ""}`;
        else if (operator === "<") p.innerHTML = `<b>Decrease Data Pointer</b> - Moves the pointer to the left ${count} time${count > 1 ? "s" : ""}`;
        else if (operator === "+") p.innerHTML = `<b>Increment Byte of Data Pointer</b> - Increases the value of the byte at the pointer's current location by ${count}`;
        else if (operator === "-") p.innerHTML = `<b>Decrement Byte of Data Pointer</b> - Decreases the value of the byte at the pointer's current location by ${count}`;
        else if (operator === ",") p.innerHTML = `<b>Accept one byte of input</b> - Takes an input and replaces the byte value at the pointer's current location`;
        else if (operator === ".") p.innerHTML = `<b>Output value of Data Pointer</b> - Prints out the character corresponding to the value at the pointer's current location`;
        else if (operator === "[") p.innerHTML = `<b>Open Loop Bracket</b> - If nonzero value, execute command in square brackets '[ ]'`;
        else if (operator === "]") p.innerHTML = `<b>Close Loop Bracket</b> - If nonzero value, execute command after corresponding '[' bracket`;
        const pos = e.target.getBoundingClientRect();
        const tooltipPos = tooltip.getBoundingClientRect();
        tooltip.style.left = pos.x + pos.width / 2 + "px";
        tooltip.style.top = pos.y + pos.height / 2 - tooltipPos.height * 4 + "px";
        document.body.append(tooltip);
    }
};
let $3f2d68c8e82ce3a4$var$info = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("p", null), $3f2d68c8e82ce3a4$var$info_head = /*#__PURE__*/ (0, $35c245714e2863e8$export$dda1d9f60106f0e9)("p", null);
function $3f2d68c8e82ce3a4$var$gcd(c, a) {
    return 0 === a ? c : $3f2d68c8e82ce3a4$var$gcd(a, c % a);
}
function $3f2d68c8e82ce3a4$var$inverse_mod(c, a) {
    for(var f = 1, d = 0, b; a;)b = f, f = d, d = b - d * (c / a | 0), b = c, c = a, a = b % a;
    return f;
}
function $3f2d68c8e82ce3a4$var$shortest_str(c) {
    for(var a = 0, f = 1; f < c.length; f++)c[f].length < c[a].length && (a = f);
    return a;
}
for(var $3f2d68c8e82ce3a4$var$map = [], $3f2d68c8e82ce3a4$var$plus_map = [
    ""
], $3f2d68c8e82ce3a4$var$minus_map = [
    ""
], $3f2d68c8e82ce3a4$var$iter = !0, $3f2d68c8e82ce3a4$var$repeat = 2, $3f2d68c8e82ce3a4$var$start, $3f2d68c8e82ce3a4$var$i = 1; 256 > $3f2d68c8e82ce3a4$var$i; $3f2d68c8e82ce3a4$var$i++)$3f2d68c8e82ce3a4$var$plus_map[$3f2d68c8e82ce3a4$var$i] = $3f2d68c8e82ce3a4$var$plus_map[$3f2d68c8e82ce3a4$var$i - 1] + "+", $3f2d68c8e82ce3a4$var$minus_map[$3f2d68c8e82ce3a4$var$i] = $3f2d68c8e82ce3a4$var$minus_map[$3f2d68c8e82ce3a4$var$i - 1] + "-";
for(var $3f2d68c8e82ce3a4$var$x = 0; 256 > $3f2d68c8e82ce3a4$var$x; $3f2d68c8e82ce3a4$var$x++){
    $3f2d68c8e82ce3a4$var$map[$3f2d68c8e82ce3a4$var$x] = [];
    for(var $3f2d68c8e82ce3a4$var$y = 0; 256 > $3f2d68c8e82ce3a4$var$y; $3f2d68c8e82ce3a4$var$y++){
        var $3f2d68c8e82ce3a4$var$delta = $3f2d68c8e82ce3a4$var$y - $3f2d68c8e82ce3a4$var$x;
        128 < $3f2d68c8e82ce3a4$var$delta && ($3f2d68c8e82ce3a4$var$delta -= 256);
        -128 > $3f2d68c8e82ce3a4$var$delta && ($3f2d68c8e82ce3a4$var$delta += 256);
        $3f2d68c8e82ce3a4$var$map[$3f2d68c8e82ce3a4$var$x][$3f2d68c8e82ce3a4$var$y] = 0 <= $3f2d68c8e82ce3a4$var$delta ? $3f2d68c8e82ce3a4$var$plus_map[$3f2d68c8e82ce3a4$var$delta] : $3f2d68c8e82ce3a4$var$minus_map[-$3f2d68c8e82ce3a4$var$delta];
    }
}
function $3f2d68c8e82ce3a4$var$next() {
    $3f2d68c8e82ce3a4$var$iter = !1;
    for(var c = 0; 256 > c; c++)for(var a = 1; 40 > a; a++)for(var f = $3f2d68c8e82ce3a4$var$inverse_mod(a, 256) & 255, d = 1; 40 > d; d++)if (1 === $3f2d68c8e82ce3a4$var$gcd(a, d)) {
        if (a & 1) {
            var b = 0;
            var e = c * f & 255;
        } else for(b = c, e = 0; 256 > e && b; e++)b = b - a & 255;
        0 === b && (b = d * e & 255, a + d + 5 < $3f2d68c8e82ce3a4$var$map[c][b].length && ($3f2d68c8e82ce3a4$var$map[c][b] = "[" + $3f2d68c8e82ce3a4$var$minus_map[a] + ">" + $3f2d68c8e82ce3a4$var$plus_map[d] + "<]>"));
        if (a & 1) b = 0, e = -c * f & 255;
        else for(b = c, e = 0; 256 > e && b; e++)b = b + a & 255;
        0 === b && (b = -d * e & 255, a + d + 5 < $3f2d68c8e82ce3a4$var$map[c][b].length && ($3f2d68c8e82ce3a4$var$map[c][b] = "[" + $3f2d68c8e82ce3a4$var$plus_map[a] + ">" + $3f2d68c8e82ce3a4$var$minus_map[d] + "<]>"));
    }
    for(c = 0; 256 > c; c++)for(a = $3f2d68c8e82ce3a4$var$map[c], e = 0; 256 > e; e++)for(f = $3f2d68c8e82ce3a4$var$map[e], d = a[e], b = 0; 256 > b; b++)d.length + f[b].length < a[b].length && (a[b] = d + f[b]);
    --$3f2d68c8e82ce3a4$var$repeat ? ($3f2d68c8e82ce3a4$var$info_head.textContent += ".", setTimeout($3f2d68c8e82ce3a4$var$next, 0)) : ($3f2d68c8e82ce3a4$var$info_head.textContent += ". done (" + ((Date.now() - $3f2d68c8e82ce3a4$var$start) / 1E3).toFixed(2) + " seconds).", $3f2d68c8e82ce3a4$var$do_generate());
}
function $3f2d68c8e82ce3a4$var$generate(c) {
    for(var a = 0, f = c.length, d = "", b = 0; b < f; b++){
        var e = c.charCodeAt(b) & 255;
        a = [
            ">" + $3f2d68c8e82ce3a4$var$map[0][e],
            $3f2d68c8e82ce3a4$var$map[a][e]
        ];
        var g = $3f2d68c8e82ce3a4$var$shortest_str(a);
        d += a[g] + ".";
        a = e;
    }
    return d;
}
function $3f2d68c8e82ce3a4$var$do_generate() {
    if (!$3f2d68c8e82ce3a4$var$repeat) {
        var c = $3f2d68c8e82ce3a4$var$inp?.value ?? "", a = $3f2d68c8e82ce3a4$var$generate(c);
        if ($3f2d68c8e82ce3a4$var$out) $3f2d68c8e82ce3a4$var$out.value = a;
        $3f2d68c8e82ce3a4$var$info.textContent = "text length = " + c.length + " bytes\ncode length = " + a.length + " bytes\nratio = " + (a.length / (c.length || 1)).toFixed(2);
        if (!$3f2d68c8e82ce3a4$var$encoderTracked && c.length > 0) {
            $3f2d68c8e82ce3a4$var$encoderTracked = true;
            plausible('Text Encoded', {
                props: {
                    text_length: String(c.length),
                    code_length: String(a.length),
                    ratio: (a.length / (c.length || 1)).toFixed(2)
                }
            });
        }
    }
}
window.onload = function() {
    $3f2d68c8e82ce3a4$var$info_head.textContent = "Generating table .";
    $3f2d68c8e82ce3a4$var$start = new Date;
    setTimeout($3f2d68c8e82ce3a4$var$next, 0);
};
document.querySelector('footer a[href*="github.com"]')?.addEventListener('click', ()=>{
    plausible('Outbound Link: GitHub');
});


//# sourceMappingURL=repo.da68e4f2.js.map
